/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateOrganizationDTO,
  OrganizationAdminDTO,
  OrganizationGetOrganizationsParams,
  OrganizationListItemDTO,
  OrganizationListItemDTOQueryResultDTO,
  OrganizationPublicDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





export const organizationGetMyOrganizations = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationListItemDTO[]>(
      {url: `/api/Organization/my-organizations`, method: 'GET', signal
    },
      );
    }
  

export const getOrganizationGetMyOrganizationsQueryKey = () => {
    return [`/api/Organization/my-organizations`] as const;
    }

    
export const getOrganizationGetMyOrganizationsQueryOptions = <TData = Awaited<ReturnType<typeof organizationGetMyOrganizations>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetMyOrganizations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationGetMyOrganizationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationGetMyOrganizations>>> = ({ signal }) => organizationGetMyOrganizations(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationGetMyOrganizations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationGetMyOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof organizationGetMyOrganizations>>>
export type OrganizationGetMyOrganizationsQueryError = ErrorType<unknown>


export function useOrganizationGetMyOrganizations<TData = Awaited<ReturnType<typeof organizationGetMyOrganizations>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetMyOrganizations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationGetMyOrganizations>>,
          TError,
          Awaited<ReturnType<typeof organizationGetMyOrganizations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationGetMyOrganizations<TData = Awaited<ReturnType<typeof organizationGetMyOrganizations>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetMyOrganizations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationGetMyOrganizations>>,
          TError,
          Awaited<ReturnType<typeof organizationGetMyOrganizations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationGetMyOrganizations<TData = Awaited<ReturnType<typeof organizationGetMyOrganizations>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetMyOrganizations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOrganizationGetMyOrganizations<TData = Awaited<ReturnType<typeof organizationGetMyOrganizations>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetMyOrganizations>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationGetMyOrganizationsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const organizationGetOrganizations = (
    params?: OrganizationGetOrganizationsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationListItemDTOQueryResultDTO>(
      {url: `/api/Organization`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getOrganizationGetOrganizationsQueryKey = (params?: OrganizationGetOrganizationsParams,) => {
    return [`/api/Organization`, ...(params ? [params]: [])] as const;
    }

    
export const getOrganizationGetOrganizationsQueryOptions = <TData = Awaited<ReturnType<typeof organizationGetOrganizations>>, TError = ErrorType<unknown>>(params?: OrganizationGetOrganizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetOrganizations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationGetOrganizationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationGetOrganizations>>> = ({ signal }) => organizationGetOrganizations(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationGetOrganizations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationGetOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof organizationGetOrganizations>>>
export type OrganizationGetOrganizationsQueryError = ErrorType<unknown>


export function useOrganizationGetOrganizations<TData = Awaited<ReturnType<typeof organizationGetOrganizations>>, TError = ErrorType<unknown>>(
 params: undefined |  OrganizationGetOrganizationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetOrganizations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationGetOrganizations>>,
          TError,
          Awaited<ReturnType<typeof organizationGetOrganizations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationGetOrganizations<TData = Awaited<ReturnType<typeof organizationGetOrganizations>>, TError = ErrorType<unknown>>(
 params?: OrganizationGetOrganizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetOrganizations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationGetOrganizations>>,
          TError,
          Awaited<ReturnType<typeof organizationGetOrganizations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationGetOrganizations<TData = Awaited<ReturnType<typeof organizationGetOrganizations>>, TError = ErrorType<unknown>>(
 params?: OrganizationGetOrganizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetOrganizations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOrganizationGetOrganizations<TData = Awaited<ReturnType<typeof organizationGetOrganizations>>, TError = ErrorType<unknown>>(
 params?: OrganizationGetOrganizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetOrganizations>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationGetOrganizationsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const organizationCreateOrganization = (
    createOrganizationDTO: CreateOrganizationDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationAdminDTO>(
      {url: `/api/Organization/create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrganizationDTO, signal
    },
      );
    }
  


export const getOrganizationCreateOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationCreateOrganization>>, TError,{data: CreateOrganizationDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof organizationCreateOrganization>>, TError,{data: CreateOrganizationDTO}, TContext> => {
    
const mutationKey = ['organizationCreateOrganization'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationCreateOrganization>>, {data: CreateOrganizationDTO}> = (props) => {
          const {data} = props ?? {};

          return  organizationCreateOrganization(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationCreateOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof organizationCreateOrganization>>>
    export type OrganizationCreateOrganizationMutationBody = CreateOrganizationDTO
    export type OrganizationCreateOrganizationMutationError = ErrorType<unknown>

    export const useOrganizationCreateOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationCreateOrganization>>, TError,{data: CreateOrganizationDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof organizationCreateOrganization>>,
        TError,
        {data: CreateOrganizationDTO},
        TContext
      > => {

      const mutationOptions = getOrganizationCreateOrganizationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const organizationGetOrganizationPublic = (
    organizationId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationPublicDTO>(
      {url: `/api/Organization/public/${organizationId}`, method: 'GET', signal
    },
      );
    }
  

export const getOrganizationGetOrganizationPublicQueryKey = (organizationId: number,) => {
    return [`/api/Organization/public/${organizationId}`] as const;
    }

    
export const getOrganizationGetOrganizationPublicQueryOptions = <TData = Awaited<ReturnType<typeof organizationGetOrganizationPublic>>, TError = ErrorType<unknown>>(organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetOrganizationPublic>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationGetOrganizationPublicQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationGetOrganizationPublic>>> = ({ signal }) => organizationGetOrganizationPublic(organizationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationGetOrganizationPublic>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationGetOrganizationPublicQueryResult = NonNullable<Awaited<ReturnType<typeof organizationGetOrganizationPublic>>>
export type OrganizationGetOrganizationPublicQueryError = ErrorType<unknown>


export function useOrganizationGetOrganizationPublic<TData = Awaited<ReturnType<typeof organizationGetOrganizationPublic>>, TError = ErrorType<unknown>>(
 organizationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetOrganizationPublic>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationGetOrganizationPublic>>,
          TError,
          Awaited<ReturnType<typeof organizationGetOrganizationPublic>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationGetOrganizationPublic<TData = Awaited<ReturnType<typeof organizationGetOrganizationPublic>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetOrganizationPublic>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationGetOrganizationPublic>>,
          TError,
          Awaited<ReturnType<typeof organizationGetOrganizationPublic>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationGetOrganizationPublic<TData = Awaited<ReturnType<typeof organizationGetOrganizationPublic>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetOrganizationPublic>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOrganizationGetOrganizationPublic<TData = Awaited<ReturnType<typeof organizationGetOrganizationPublic>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetOrganizationPublic>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationGetOrganizationPublicQueryOptions(organizationId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const organizationJoinOrganization = (
    organizationId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<boolean>(
      {url: `/api/Organization/join/${organizationId}`, method: 'POST', signal
    },
      );
    }
  


export const getOrganizationJoinOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationJoinOrganization>>, TError,{organizationId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof organizationJoinOrganization>>, TError,{organizationId: number}, TContext> => {
    
const mutationKey = ['organizationJoinOrganization'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationJoinOrganization>>, {organizationId: number}> = (props) => {
          const {organizationId} = props ?? {};

          return  organizationJoinOrganization(organizationId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationJoinOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof organizationJoinOrganization>>>
    
    export type OrganizationJoinOrganizationMutationError = ErrorType<unknown>

    export const useOrganizationJoinOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationJoinOrganization>>, TError,{organizationId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof organizationJoinOrganization>>,
        TError,
        {organizationId: number},
        TContext
      > => {

      const mutationOptions = getOrganizationJoinOrganizationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const organizationApplyToOrganization = (
    organizationId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<boolean>(
      {url: `/api/Organization/apply/${organizationId}`, method: 'POST', signal
    },
      );
    }
  


export const getOrganizationApplyToOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationApplyToOrganization>>, TError,{organizationId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof organizationApplyToOrganization>>, TError,{organizationId: number}, TContext> => {
    
const mutationKey = ['organizationApplyToOrganization'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationApplyToOrganization>>, {organizationId: number}> = (props) => {
          const {organizationId} = props ?? {};

          return  organizationApplyToOrganization(organizationId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationApplyToOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof organizationApplyToOrganization>>>
    
    export type OrganizationApplyToOrganizationMutationError = ErrorType<unknown>

    export const useOrganizationApplyToOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationApplyToOrganization>>, TError,{organizationId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof organizationApplyToOrganization>>,
        TError,
        {organizationId: number},
        TContext
      > => {

      const mutationOptions = getOrganizationApplyToOrganizationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const organizationGetOrganizationLogoPlaceholder = (
    organizationId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/Organization/${organizationId}/placeholder/logo`, method: 'GET', signal
    },
      );
    }
  

export const getOrganizationGetOrganizationLogoPlaceholderQueryKey = (organizationId: number,) => {
    return [`/api/Organization/${organizationId}/placeholder/logo`] as const;
    }

    
export const getOrganizationGetOrganizationLogoPlaceholderQueryOptions = <TData = Awaited<ReturnType<typeof organizationGetOrganizationLogoPlaceholder>>, TError = ErrorType<unknown>>(organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetOrganizationLogoPlaceholder>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationGetOrganizationLogoPlaceholderQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationGetOrganizationLogoPlaceholder>>> = ({ signal }) => organizationGetOrganizationLogoPlaceholder(organizationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationGetOrganizationLogoPlaceholder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationGetOrganizationLogoPlaceholderQueryResult = NonNullable<Awaited<ReturnType<typeof organizationGetOrganizationLogoPlaceholder>>>
export type OrganizationGetOrganizationLogoPlaceholderQueryError = ErrorType<unknown>


export function useOrganizationGetOrganizationLogoPlaceholder<TData = Awaited<ReturnType<typeof organizationGetOrganizationLogoPlaceholder>>, TError = ErrorType<unknown>>(
 organizationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetOrganizationLogoPlaceholder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationGetOrganizationLogoPlaceholder>>,
          TError,
          Awaited<ReturnType<typeof organizationGetOrganizationLogoPlaceholder>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationGetOrganizationLogoPlaceholder<TData = Awaited<ReturnType<typeof organizationGetOrganizationLogoPlaceholder>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetOrganizationLogoPlaceholder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationGetOrganizationLogoPlaceholder>>,
          TError,
          Awaited<ReturnType<typeof organizationGetOrganizationLogoPlaceholder>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationGetOrganizationLogoPlaceholder<TData = Awaited<ReturnType<typeof organizationGetOrganizationLogoPlaceholder>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetOrganizationLogoPlaceholder>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOrganizationGetOrganizationLogoPlaceholder<TData = Awaited<ReturnType<typeof organizationGetOrganizationLogoPlaceholder>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetOrganizationLogoPlaceholder>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationGetOrganizationLogoPlaceholderQueryOptions(organizationId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const organizationGetOrganizationHeaderPlaceholder = (
    organizationId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/Organization/${organizationId}/placeholder/header`, method: 'GET', signal
    },
      );
    }
  

export const getOrganizationGetOrganizationHeaderPlaceholderQueryKey = (organizationId: number,) => {
    return [`/api/Organization/${organizationId}/placeholder/header`] as const;
    }

    
export const getOrganizationGetOrganizationHeaderPlaceholderQueryOptions = <TData = Awaited<ReturnType<typeof organizationGetOrganizationHeaderPlaceholder>>, TError = ErrorType<unknown>>(organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetOrganizationHeaderPlaceholder>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationGetOrganizationHeaderPlaceholderQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationGetOrganizationHeaderPlaceholder>>> = ({ signal }) => organizationGetOrganizationHeaderPlaceholder(organizationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationGetOrganizationHeaderPlaceholder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationGetOrganizationHeaderPlaceholderQueryResult = NonNullable<Awaited<ReturnType<typeof organizationGetOrganizationHeaderPlaceholder>>>
export type OrganizationGetOrganizationHeaderPlaceholderQueryError = ErrorType<unknown>


export function useOrganizationGetOrganizationHeaderPlaceholder<TData = Awaited<ReturnType<typeof organizationGetOrganizationHeaderPlaceholder>>, TError = ErrorType<unknown>>(
 organizationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetOrganizationHeaderPlaceholder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationGetOrganizationHeaderPlaceholder>>,
          TError,
          Awaited<ReturnType<typeof organizationGetOrganizationHeaderPlaceholder>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationGetOrganizationHeaderPlaceholder<TData = Awaited<ReturnType<typeof organizationGetOrganizationHeaderPlaceholder>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetOrganizationHeaderPlaceholder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationGetOrganizationHeaderPlaceholder>>,
          TError,
          Awaited<ReturnType<typeof organizationGetOrganizationHeaderPlaceholder>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationGetOrganizationHeaderPlaceholder<TData = Awaited<ReturnType<typeof organizationGetOrganizationHeaderPlaceholder>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetOrganizationHeaderPlaceholder>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOrganizationGetOrganizationHeaderPlaceholder<TData = Awaited<ReturnType<typeof organizationGetOrganizationHeaderPlaceholder>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationGetOrganizationHeaderPlaceholder>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationGetOrganizationHeaderPlaceholderQueryOptions(organizationId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



